import type { AxiosInstance } from "axios";
import { getAuthOperations } from "./namespaces/auth";
import { getBillOperations } from "./namespaces/bill";
import { getCountryOperations } from "./namespaces/country";
import { getDeliveryMethodOperations } from "./namespaces/delivery-method";
import { getDiscountOperations } from "./namespaces/discount";
import { getLanguageOperations } from "./namespaces/language";
import { getManufacturerOperations } from "./namespaces/manufacturer";
import { getNoteOperations } from "./namespaces/note";
import { getOrderOperations } from "./namespaces/order";
import { getUserOperations } from "./namespaces/user";
import { getUserDataOperations } from "./namespaces/user-data";
import { getVariantOperations } from "./namespaces/variant";
import { getVoucherSerieOperations } from "./namespaces/voucher-serie";
import { getSystemOperations } from "./namespaces/system";
import { getAccountingPostingOperations } from "./namespaces/accounting-posting";
import { getProductsImportOperations } from "./namespaces/products-import";
import { getDocumentOperations } from "./namespaces/document";

export const createExonnApi = (client: AxiosInstance) => {
  return {
    accountingPosting: getAccountingPostingOperations(client),
    auth: getAuthOperations(client),
    bill: getBillOperations(client),
    country: getCountryOperations(client),
    deliveryMethod: getDeliveryMethodOperations(client),
    discount: getDiscountOperations(client),
    document: getDocumentOperations(client),
    language: getLanguageOperations(client),
    manufacturer: getManufacturerOperations(client),
    note: getNoteOperations(client),
    order: getOrderOperations(client),
    user: getUserOperations(client),
    userData: getUserDataOperations(client),
    variant: getVariantOperations(client),
    voucherSerie: getVoucherSerieOperations(client),
    productsImport: getProductsImportOperations(client),
    system: getSystemOperations(client),
    get client() {
      return client;
    },
  };
};

export type ExonnApi = ReturnType<typeof createExonnApi>;
